import { render, staticRenderFns } from "./hot-recommend.vue?vue&type=template&id=5da5b1b6&scoped=true&"
import script from "./hot-recommend.vue?vue&type=script&lang=js&"
export * from "./hot-recommend.vue?vue&type=script&lang=js&"
import style0 from "./hot-recommend.vue?vue&type=style&index=0&id=5da5b1b6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5b1b6",
  null
  
)

export default component.exports